<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="mobileVersion ? 'fs' : 'lg-fix-h'">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ !isNewProduct ? $t('invoices.invoices_issuing.step4.add_product_plural') : $t('products.new')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-8 overflow-x-auto overflow-y-auto"
        :style="mobileVersion ? 'height: 80vh;' : 'height: 60vh;'">
        <el-form class="h-full flex flex-row overflow-y-auto" :model="form" ref="ruleForm" :rules="rules">
          <step-4-product-table v-model="form.products" :id-cliente="idCliente" @applyToggle="toggleNewProduct" :ruleForm="$refs.ruleForm" />
        </el-form>
        <!-- <div v-if="isTax" class="h-16 text-white px-4 mt-4"> -->
        <div v-if="false" class="h-16 text-white px-4 mt-4">
          <h2 class="font-bold ml-2">Impuestos de cada producto</h2>
          <div v-for="product in form.products" :key="product.idProducto" class="flex items-center justify-between ml-4">
            <p>{{product.ItemDescription}}<span>{{getProductTax(product)}}</span></p>
          </div>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="flex flex-row w-full justify-between">
        <!-- <base-button v-if="!showLine" mode="secondary-phantom-blue" class="w-full mx-2" :text="$t('app.back')" @click="doBack('ruleForm')" />
        <base-button v-if="showLine" mode="secondary-phantom-blue" class="w-full mx-2" :text="$t('app.next')" @click="doNext('ruleForm')" />
        <base-button v-else mode="secondary-phantom-blue" class="w-full mx-2" :text="'Agregar Productos'" @click="addProduct('ruleForm')" />
        <base-button v-if="form.products.length === 1" mode="secondary-phantom-blue" class="w-full mx-2" :text="'Revisar Impuestos'" @click="doNext('ruleForm')" /> -->
        <base-button class="w-full mx-2" @click="showTable()" mode="secondary" :text="!isNewProduct ? $t('app.cancel') : $t('app.back')" />
        <base-button mode="primary" class="w-full mx-2" :text="!isNewProduct ? $t('invoices.invoices_issuing.step4.add_product') : $t('app.save')" @click="productHandler('ruleForm')" />
      </div> 
    </template>
  </base-dialog-button>
</template>
    
<script>
import { i18n } from '@/i18n'

import { getProductsImpuestosPag } from '@/services/configurations/getProductsImpuestosPag'
import { createProductWithTaxes } from '@/services/configurations/createProductWithTaxes'

import Step4ProductTable from '@/components/Step4ProductTable.vue'

export default {
  /* eslint-disable camelcase */
  name: 'import-products-dialog',
  components: {
    Step4ProductTable
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    },
    idCliente: [Number, String]
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      activeName: 'es',
      form: this.getDefaultForm(),
      isNewProduct: false,
      rules: {}
    }
  },
  computed: {
    isTax: function () {
      return this.form.products.length > 0
    },
    getIdCliente: function () {
      return this.$store.getters['invoicesIssuing/form'].issuer.IdCliente
    },
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value !== oldValue) {
        this.isOpen = value
        this.resetForm()
      }
    },
  },
  mounted () {
  },
  methods: {
    getDefaultForm: function () {
      return {
        products: []
      }
    },
    toggleNewProduct: function () {
      this.isNewProduct = !this.isNewProduct
    },
    showTable: function () {
      this.isNewProduct ? this.$refs.ruleForm.$children[0].toggleNewProduct() : this.toggleDialog()
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.isNewProduct = false
      this.resetForm()
      this.$emit('toggleDialog')
    },
    resetForm () {
      this.form = this.getDefaultForm()
    },
    doNext: function (ruleForm) {
      try {
        this.$store.commit('setIsLoading', true)
        this.$refs[ruleForm].validate(async valid => {
          if (!valid) {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          } else {
            this.showProducts = false
          }
        })
      } catch (error) {
        this.isLoadingUpdate = false
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    doBack: function (ruleForm) {
      this.showProducts = true
    },
    productHandler: function (formName) {
      return this.isNewProduct ? this.createProduct(formName) : this.addProduct(formName) 
    },      
    createProduct: function (formName) {
      try {
        this.$store.commit('setIsLoading', true)
        const product = this.$refs.ruleForm.$children[0].form
        this.$refs.ruleForm.$children[0].$refs[formName].validate(async (valid) => {
          if (!valid) {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          } else {
            const params = {
              idProducto: -1,
              idCliente: this.getIdCliente,
              ItemDescription: product.ItemDescription,
              UnitOfMeasure: product.UnitOfMeasure,
              UnitPriceWithoutTax: product.UnitPriceWithoutTax,
              ArticleCode: product.ArticleCode,
              Impuestos: product.impuestos
            }
            const response = await createProductWithTaxes(params)
            if (response.blnError === true) {
              this.doFeedback(`${response.msgError} [${response.codError}]`)
            } else {
              this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
              this.$refs.ruleForm.$children[0].form = this.$refs.ruleForm.$children[0].getDefaultForm()
              this.showTable()
            }
          }
        })
      } catch (error) {
        this.$refs.ruleForm.$children[0].form = this.$refs.ruleForm.$children[0].getDefaultForm()
        this.showTable()
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    addProduct: function (formName) {
      try {
        this.$store.commit('setIsLoading', true)
        const data = this.form.products
        // Comprobamos si hay productos seleccionados  
        if (data.length > 0) {
          const addedProducts = []
          // Comprobamos que los productos seleccionados contengan total
          if (!data.some(element => 
            element.totalConImpuesto === undefined || 
            element.totalConImpuesto === null || 
            element.totalConImpuesto === '')) {
            data.forEach(element => {
              this.$refs[formName].validate(valid => {
                if (valid) {
                  const params = {
                    descuentos: [
                      {
                        incluyeDescuento: element.editDescuento || false,
                        descuento: element.editDescuento ? element.descuento : '',
                        cuota: element.cuota || null
                      }
                    ],
                    // taxes: Impuestos seleccionados para la línea (Actualmente limitado a 1)
                    taxes: element.Taxes,
                    // impuestos: Impuestos disponibles para modificación en línea
                    impuestos: element.Impuestos,
                    idCliente: this.idCliente || data[0].idCliente,
                    idProducto: element.idProducto || null,
                    codProducto: element.ArticleCode || null,
                    descripcion: element.ItemDescription || null,
                    precioUnitario: element.UnitPriceWithoutTax || null,
                    cantidad: element.cantidad || element.cantidad === 0 ? element.cantidad : null,
                    subtotal: element.subtotal || element.subtotal === 0 ? element.subtotal : null,
                    total: element.total || element.total === 0 ? element.total : null,
                    totalConImpuesto: element.totalConImpuesto || element.totalConImpuesto === 0 ? element.totalConImpuesto : null,
                    UnitOfMeasure: element.UnitOfMeasure || null,
                  }
                  
                  addedProducts.push(params)
                } else {
                  this.doFeedback(i18n.t('feedback.error.process_data_error'))
                }
              })  
            })
            this.$emit('applyDialog', addedProducts)
          } else {
            this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_total'))
          }
        } else {
          this.doFeedback(i18n.t('app.select_data'))
        }
      } catch (error) {
        this.isLoadingUpdate = false
        this.doFeedback(error)
      } finally {
        this.showProducts = false
        this.$store.commit('setIsLoading', false)
      }
    },
    getProductTax: async function (product, params = false) {
      try {
        const data = await getProductsImpuestosPag({}, { idProducto: product.idProducto || product })
        return params ? data : data.Respuesta[0].TaxRate
      } catch (error) {
        this.doFeedback()
      } 
    }
  }
}
</script>
<style scoped>
</style>
